import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import List from 'list.js'
import './Table.css'
import { UpsertTract } from '@components/tract/UpsertTract'

/* type TableProps = {
    headers: string[]
    prefix: string
    sortHeaders?: string[]
    sortEnable?: boolean
    rows: (string | ReactElement)[][]
    highlightes?: number[]
    cardHeader?: ReactElement
    defaultElement?: ReactElement
    style?: Object
    setShowTable: (show: boolean) => void
    isButton: boolean
    tracts?: Tract[]
    setAssignTractsList: (list: Tract[]) => void
    setIsAddTract: (show: boolean) => void
    project?: Project
} */

export const Table = ({
    headers,
    rows,
    sortHeaders,
    sortEnable = true,
    prefix,
    highlightes,
    cardHeader,
    children,
    defaultElement,
    style,
    setShowTable,
    isButton,
    tracts,
    setAssignTractsList,
    setIsAddTract,
    project,
}) => {
    useEffect(() => {
        if (rows.length > 0 && sortHeaders) {
            // @todo what the fuck is this
            new List(prefix, {
                valueNames: sortHeaders,
            })
        }
    }, [sortHeaders, rows, prefix])
    const [showAdd, showHideAdd] = useState(false)
    // let assignedTract = []
    const runsheet = useWireValue(store.currentRunsheet)
    
    const addTract = () => {
        const newAssignedTracts = [...(tracts || [])]
        
        setAssignTractsList(newAssignedTracts)
        
        const newGrossAcreage = newAssignedTracts.reduce((sum, { grossAcreage }) => {
            const _grossAcreage = grossAcreage
            
            return isNaN(_grossAcreage) ? sum : sum + _grossAcreage
        }, 0)
        
        // Update runsheet through proper state management instead of direct mutation
        actions.updateRunsheet({
            ...runsheet,
            tracts: newAssignedTracts,
            grossAcreage: newGrossAcreage,
        })
        
        setIsAddTract(true)
        setShowTable(false)
    }
    
    return (
        <div className="m-0 card table-component" id={prefix}>
            <div className="p-0 border-0 card-header">
                <div className="items-center">
                    <div className="flex items-center p-0 col">
                        <form className="w-100">
                            <div className="input-group input-group-flush search-field">
                                <input className="p-3 search form-control" type="search" placeholder="Search" />
                                {isButton && (
                                    <button
                                        type="button"
                                        className="mr-3 btn btn-primary"
                                        onClick={() => showHideAdd(!showAdd)}>
                                        Create Tract
                                    </button>
                                )}
                                {isButton && (
                                    <button
                                        type="button"
                                        className="mr-3 btn btn-primary"
                                        onClick={() => addTract()}>
                                        Add Tract(s)
                                    </button>
                                )}
                                {isButton && (
                                    <button
                                        type="button"
                                        className="mr-3 btn btn-primary btn-outline"
                                        onClick={() => setShowTable(false)}>
                                        Cancel
                                    </button>
                                )}
                            </div>
                        </form>
                        {cardHeader}
                    </div>
                </div>
            </div>
            {rows && rows.length ? (
                <div className="table-responsive">
                    <table className="table table-sm table-nowrap card-table" style={style}>
                        <thead>
                            <tr>
                                {headers.map((header, thIndex) => {
                                    const props = {}
                                    
                                    if (header) {
                                        props['data-sort'] = sortHeaders ? sortHeaders[thIndex] : ''
                                    }
                                    
                                    return (
                                        <th key={thIndex}>
                                            <a
                                                className={`${
                                                    props['data-sort'] && sortEnable ? 'sort' : ''
                                                } text-muted`}
                                                {...props}
                                                onClick={e => e.preventDefault()}
                                                href="#!">
                                                {header}
                                            </a>
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody className="list font-size-base">
                            {rows?.map((values, trIndex) => {
                                return (
                                    <tr
                                        key={`c-${trIndex}`}
                                        className={highlightes && highlightes[trIndex] === 1 ? 'table-success' : ''}>
                                        {values.map((value, tdIndex) => {
                                            return (
                                                <td key={`td-${trIndex}-${tdIndex}`}>
                                                    {typeof value === 'string' ? (
                                                        <span
                                                            className={
                                                                sortEnable && sortHeaders ? sortHeaders[tdIndex] : ''
                                                            }>
                                                            {value}
                                                        </span>
                                                    ) : (
                                                        value
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                defaultElement
            )}
            {children}
            {showAdd && (
                <UpsertTract
                    id="create-tract"
                    showAdd={showAdd}
                    showHideAdd={showHideAdd}
                    project={project}
                    setIsAddTract={setIsAddTract} />
            )}
        </div>
    )
}
